import PropTypes from 'prop-types';

import styles from './LegendItem.module.scss';

const LegendItem = ({ children, prefix, className, ...props }) => {
    return (
        <div
            className={[styles.item, className].join(' ')}
            data-testid={props['data-testid']}
        >
            { prefix && <div className={styles.prefix}>
                {prefix}
            </div>}
            <div className={['govuk-body-s', styles.label].join(' ')}>
                {children}
            </div>
        </div>
    );
};

LegendItem.propTypes = {
    children: PropTypes.any,
    prefix: PropTypes.any,
    className: PropTypes.string,
    'data-testid': PropTypes.string
};

export default LegendItem;
